import type { SentryInitializationConfig } from '#src/telemetry/sentry/sentry_config.ts';
import { scrubPii } from '#src/telemetry/sentry/sentry_utils.ts';
import * as Sentry from '@sentry/react';

export function initSentry(config: SentryInitializationConfig): void {
  Sentry.init({
    enabled: config.enabled,
    environment: config.environment,
    dsn: config.dsn,
    debug: config.debug,
    release: config.release,
    tunnel: config.tunnel,
    sampleRate: 1.0,
    maxBreadcrumbs: 100,
    tracesSampleRate: 0.5,
    tracePropagationTargets: ['localhost', /^\//],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    sendDefaultPii: false,
    beforeSend: event => {
      scrubPii(event);
      return event;
    },
    ignoreErrors: [/__firefox__/],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        minReplayDuration: 5000,
        networkDetailAllowUrls: [window.location.origin],
        blockAllMedia: true,
        maskAllText: true,
        maskAllInputs: true,
      }),
      Sentry.feedbackIntegration({
        autoInject: true,
        showBranding: false,
        showName: true,
        showEmail: true,
        isEmailRequired: true,
        enableScreenshot: false,
        nameLabel: 'Name',
        namePlaceholder: 'Your name',
        triggerLabel: 'Help',
        formTitle: 'How can we help?',
        submitButtonLabel: 'Send',
        isRequiredLabel: '*',
        emailPlaceholder: 'email@example.com',
        messageLabel: 'Message',
        messagePlaceholder:
          'Describe any problems you encountered, or feel free to ask questions or share ideas with us.',
        successMessageText: 'Thank you! We will get back to you as soon as possible.',
        colorScheme: 'light',
        themeLight: {
          foreground: '#463355',
          background: '#ffffff',
          accentForeground: '#ffffff',
          accentBackground: '#775ccf',
        },
      }),
    ],
  });
}
